import React from "react";

import scrollbarSize from "dom-helpers/scrollbarSize";

import MeetingsHealth from "./MeetingsHealth";
import MeetWith from "./MeetWith";
import SmallCalendar from "./SmallCalendar";

import styles from "./BasePanel.module.css";

export default function BasePanel() {
	const style = {
		paddingRight: `calc(12px + ${scrollbarSize()}px)`,
	};

	return (
		<div className={styles.body} style={style}>
			<SmallCalendar />
			<MeetWith />
			<MeetingsHealth />
		</div>
	);
}
